// extracted by mini-css-extract-plugin
export default {"imageWrapper":"eL-z","twoColumnImage":"fL-z"};